/**
 * @file DealOverviewTab.tsx
 * @description Вкладка «Обзор» карточки сделки (phase09; phase19.31 —
 * минимум по SC50/SC61): то, чего нет в строке сведений, — источник словом
 * («Telegram», а не `telegram`), вид стадии словами, даты, итог закрытия.
 *
 * Сумма, срок, ответственный, клиент и воронка — в строке сведений под
 * шапкой, здесь не повторяются. Карточку сделки целиком перестраивает
 * phase19.18.
 */

import { SectionCard } from "../../ui/SectionCard";
import { DEAL_LOST_REASON_LABEL, STAGE_KIND_LABEL, type DealDto } from "../../../lib/api-crm";
import { dealSourceLabel } from "../../../lib/crm-deal-view";
import { formatShopDate, formatShopDateTime } from "../../../lib/shop-time";

interface Row {
  label: string;
  value: string;
}

/** Строки «Сведений»: пустые поля не показываем. */
function overviewRows(deal: DealDto): Row[] {
  const rows: (Row | null)[] = [
    { label: "Вид стадии", value: STAGE_KIND_LABEL[deal.currentStageKind] },
    { label: "Источник", value: dealSourceLabel(deal.source) ?? "не указан" },
    { label: "Создана", value: formatShopDateTime(deal.createdAt) },
    { label: "Изменена", value: formatShopDateTime(deal.updatedAt) },
    deal.closedAt ? { label: "Закрыта", value: formatShopDate(deal.closedAt) } : null,
    deal.lostReason
      ? {
          label: "Причина",
          value: [DEAL_LOST_REASON_LABEL[deal.lostReason], deal.lostReasonNote].filter(Boolean).join(" — "),
        }
      : null,
  ];
  return rows.filter((row): row is Row => row !== null);
}

export function DealOverviewTab({ deal }: { deal: DealDto }) {
  return (
    <SectionCard title="Сведения">
      <dl className="grid grid-cols-1 gap-x-6 gap-y-3 md:grid-cols-2">
        {overviewRows(deal).map((row) => (
          <div key={row.label} className="flex min-w-0 flex-col gap-0.5">
            <dt className="type-caption text-on-surface-variant">{row.label}</dt>
            <dd className="type-body break-words text-on-surface">{row.value}</dd>
          </div>
        ))}
      </dl>
    </SectionCard>
  );
}
